module.exports = "<div>\n    <ul class=\"nav nav-tabs\">\n        <li ui-sref=\"r.in.top.tonsDashboard.plant({\n            companyId: company.id\n        })\" ng-repeat=\"company in vm.store.list\" ui-sref-active=\"active\">\n            <a>{{company.name}}</a>\n        </li>\n    </ul>\n    <div class=\"flip-container\">\n        <div class=\"panel panel-default blnd-panel\">\n            <div class=\"panel-body\">\n                <div ui-view class=\"plant-view\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/tons/templates/main.html
// module id = 722
// module chunks = 0